import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const e = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 60 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx("circle", { cx: "30", cy: "30", r: "29", fill: "white", stroke: "black", strokeWidth: "2" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.104 34.926L34.317 55.402L40.88 48.314C42.634 42.944 41.997 40.441 37.73 37.026C46.734 36.106 48.3 32.217 46.13 24.688L26.18 5C19.829 10.477 17.365 13.502 19.092 18.65L22.767 22.851L19.092 23.376C13.118 26.145 11.719 28.541 14.104 34.926Z",
      fill: "url(#paint0_linear)"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M38 21.5C35.025 20.975 28.45 20.81 19 18.5L22.5 23L38 21.5Z", fill: "url(#paint1_linear)" }),
  /* @__PURE__ */ s.jsx("path", { d: "M23.5 38L38.684 37L41 40.5L41.5 41.5L41.82 42.929L23.5 38Z", fill: "url(#paint2_linear)" }),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs("linearGradient", { id: "paint0_linear", x1: "30", y1: "5", x2: "30", y2: "55.402", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ s.jsx("stop", { offset: "0.027", stopColor: "#2ED9C3" }),
      /* @__PURE__ */ s.jsx("stop", { offset: "0.628", stopColor: "#00CE7C" }),
      /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#1426F2" })
    ] }),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "30.298",
        y1: "16.813",
        x2: "30.298",
        y2: "42.929",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#398175" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#081E51" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "30.298",
        y1: "16.813",
        x2: "30.298",
        y2: "42.929",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#398175" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#081E51" })
        ]
      }
    )
  ] })
] });
export {
  e as Z
};
